
<div class="component-modal-header">
  <span class="modal-title">{{title}}</span>

  <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span class="pi pi-times"></span></button>
</div>

<div class="modal-body">
  <div class="mb-2 animated fadeIn">
    <div class="row">
      <div class="col-md-12">

        <p-table
          [autoLayout]="true"
          [value]="allItems"
        >
          <ng-template pTemplate="header">
              <tr>
                <th>Status</th>
                <th>Workflow Type</th>
                <th>Reason</th>
                <th *ngIf="isRejected">Comment from site operator</th>
                <th>Asset</th>
                <th>Created By</th>
                <th>Site</th>
                <th>Start</th>
                <th>End</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.status }}</td>
              <td>{{ item.workflowType === 'ASSET_BOOKING_REQUEST' ? 'New Booking' : 'Cancel Booking' }}</td>
              <td>{{ item.reason }}</td>
              <td>{{ item.rejectionReason }}</td>
              <td>{{ item.asset.name }}</td>
              <td>{{ item.createdBy }}</td>
              <td>{{ item.site.name }}</td>
              <td>{{ item.startTime | date: 'dd/MM/yy HH:mm'  }}</td>
              <td>{{ item.endTime | date: 'dd/MM/yy HH:mm'  }}</td>
              <td *ngIf="!isRejected"><button type="button" class="btn btn-primary btn-link text-left" (click)="open(item)">open</button></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="10">No data found</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
